export default __webpack_public_path__ + "static/media/banner.d290f7fe.jpg";